import { BaseClient } from '../BaseClient';
import { PropertyContact, PropertyContactList } from '../compiled-protos/property';
import { PropertyServiceClient } from '../compiled-protos/property.client';

class PropertyContactClient extends BaseClient {
  self: PropertyServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new PropertyServiceClient(this.transport);
  }

  public async Create(req: PropertyContact) {
    return await this.self.createPropertyContact(req, this.getMetaData()).response;
  }

  public async Update(req: PropertyContact) {
    return await this.self.updatePropertyContact(req, this.getMetaData()).response;
  }

  public async Delete(req: PropertyContact) {
    return await this.self.deletePropertyContact(req, this.getMetaData()).response;
  }

  public async BatchGet(req: PropertyContact) {
    return await this.self.batchGetPropertyContacts(req, this.getMetaDataWithoutCache())
      .response;
  }

  /**
   * Returns the active contacts for a property, billing contact first.
   * @param propertyId the property id
   */
  public async listForProperty(propertyId: number) {
    const req = PropertyContact.create({ propertyId, isActive: 1 });
    return await this.BatchGet(req);
  }
}

export { PropertyContact, PropertyContactList, PropertyContactClient };
